import { useMutation, UseMutationResult } from 'react-query';

import { getTokenWithType } from './useAuth';

import { cleanProcedure } from 'utils/urls';

import { ErrorModal } from 'types/modalTypes';

export async function formatProcedure({
  accountId,
  content,
}: TVariables): Promise<TResult> {
  const response = await fetch(cleanProcedure(accountId), {
    method: 'POST',
    headers: {
      Authorization: getTokenWithType(),
      'content-type': 'application/json',
    },
    body: JSON.stringify(content),
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: string;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  accountId: number;
  content: string;
};

type TSnapshot = unknown;

function useCleanProcedure(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  return useMutation(async (params: TVariables) => {
    const fetchResponse = await formatProcedure(params);
    if (fetchResponse.Errors) throw fetchResponse;
    return fetchResponse;
  });
}

export { useCleanProcedure };
